import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllCredentialsService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";

  const allCredentialsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CREDENTIALS,
      page,
      debouncedQuery,
      per_page,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CREDENTIALS,
        searchParams: {
          page,
          //   "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          per_page,
          include: "credentiable.segment",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allCredentialsService },
    states: { searchQuery, setSearchQuery },
  };
};
